// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Mover-Leaver Report Styles */

.lateral-movement-report {
  padding: 20px;
}

/* Summary Cards */
.lateral-movement-report .card {
  transition: transform 0.2s, box-shadow 0.2s;
}

.lateral-movement-report .card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1) !important;
}

.lateral-movement-report .card-header {
  border-bottom: 2px solid #f0f0f0;
}

/* Tabs */
.lateral-movement-report .nav-tabs .nav-link {
  color: #6c757d;
  border: none;
  border-bottom: 3px solid transparent;
  padding: 12px 20px;
  font-weight: 500;
  cursor: pointer;
  background: none;
}

.lateral-movement-report .nav-tabs .nav-link:hover {
  background-color: #f8f9fa;
  border-bottom-color: #dee2e6;
}

.lateral-movement-report .nav-tabs .nav-link.active {
  color: #0d6efd;
  border-bottom-color: #0d6efd;
  background-color: #fff;
}

/* Table Styling */
.lateral-movement-report .table-hover tbody tr:hover {
  background-color: #f8f9fa;
  cursor: pointer;
}

.lateral-movement-report .table thead th {
  background-color: #f8f9fa;
  border-bottom: 2px solid #dee2e6;
  font-weight: 600;
  color: #495057;
  padding: 12px;
}

.lateral-movement-report .table tbody td {
  padding: 12px;
  vertical-align: middle;
}

/* Badges */
.lateral-movement-report .badge {
  padding: 6px 12px;
  font-size: 0.85em;
  font-weight: 500;
}

/* List Groups */
.lateral-movement-report .list-group-item {
  border-left: none;
  border-right: none;
  padding: 16px 0;
}

.lateral-movement-report .list-group-item:first-child {
  border-top: none;
}

.lateral-movement-report .list-group-item:last-child {
  border-bottom: none;
}

/* Filters */
.lateral-movement-report .form-label {
  color: #495057;
  margin-bottom: 8px;
  font-size: 0.9em;
}

.lateral-movement-report .form-select {
  border: 1px solid #ced4da;
  border-radius: 4px;
  padding: 8px 12px;
}

.lateral-movement-report .form-select:focus {
  border-color: #0d6efd;
  box-shadow: 0 0 0 0.2rem rgba(13, 110, 253, 0.25);
}

/* Summary Stats Row */
.lateral-movement-report .change-stat-item {
  border-left: 3px solid #0d6efd;
  padding-left: 12px;
  margin-bottom: 8px;
}

/* Loading State */
.lateral-movement-report .spinner-border {
  width: 3rem;
  height: 3rem;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .lateral-movement-report .col-md-3 {
    margin-bottom: 16px;
  }

  .lateral-movement-report .table {
    font-size: 0.9em;
  }

  .lateral-movement-report .nav-tabs .nav-link {
    padding: 10px 12px;
    font-size: 0.9em;
  }
}

/* Empty State */
.lateral-movement-report .empty-state {
  padding: 60px 20px;
  text-align: center;
  color: #6c757d;
}

.lateral-movement-report .empty-state i {
  font-size: 4em;
  margin-bottom: 20px;
  opacity: 0.5;
}
`, "",{"version":3,"sources":["webpack://./src/components/LateralMovementReport.css"],"names":[],"mappings":"AAAA,+BAA+B;;AAE/B;EACE,aAAa;AACf;;AAEA,kBAAkB;AAClB;EACE,2CAA2C;AAC7C;;AAEA;EACE,2BAA2B;EAC3B,mDAAmD;AACrD;;AAEA;EACE,gCAAgC;AAClC;;AAEA,SAAS;AACT;EACE,cAAc;EACd,YAAY;EACZ,oCAAoC;EACpC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA,kBAAkB;AAClB;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;EAChC,gBAAgB;EAChB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA,WAAW;AACX;EACE,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,YAAY;AACZ;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,iDAAiD;AACnD;;AAEA,sBAAsB;AACtB;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,kBAAkB;AAClB;EACE,WAAW;EACX,YAAY;AACd;;AAEA,2BAA2B;AAC3B;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;AACF;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,YAAY;AACd","sourcesContent":["/* Mover-Leaver Report Styles */\n\n.lateral-movement-report {\n  padding: 20px;\n}\n\n/* Summary Cards */\n.lateral-movement-report .card {\n  transition: transform 0.2s, box-shadow 0.2s;\n}\n\n.lateral-movement-report .card:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1) !important;\n}\n\n.lateral-movement-report .card-header {\n  border-bottom: 2px solid #f0f0f0;\n}\n\n/* Tabs */\n.lateral-movement-report .nav-tabs .nav-link {\n  color: #6c757d;\n  border: none;\n  border-bottom: 3px solid transparent;\n  padding: 12px 20px;\n  font-weight: 500;\n  cursor: pointer;\n  background: none;\n}\n\n.lateral-movement-report .nav-tabs .nav-link:hover {\n  background-color: #f8f9fa;\n  border-bottom-color: #dee2e6;\n}\n\n.lateral-movement-report .nav-tabs .nav-link.active {\n  color: #0d6efd;\n  border-bottom-color: #0d6efd;\n  background-color: #fff;\n}\n\n/* Table Styling */\n.lateral-movement-report .table-hover tbody tr:hover {\n  background-color: #f8f9fa;\n  cursor: pointer;\n}\n\n.lateral-movement-report .table thead th {\n  background-color: #f8f9fa;\n  border-bottom: 2px solid #dee2e6;\n  font-weight: 600;\n  color: #495057;\n  padding: 12px;\n}\n\n.lateral-movement-report .table tbody td {\n  padding: 12px;\n  vertical-align: middle;\n}\n\n/* Badges */\n.lateral-movement-report .badge {\n  padding: 6px 12px;\n  font-size: 0.85em;\n  font-weight: 500;\n}\n\n/* List Groups */\n.lateral-movement-report .list-group-item {\n  border-left: none;\n  border-right: none;\n  padding: 16px 0;\n}\n\n.lateral-movement-report .list-group-item:first-child {\n  border-top: none;\n}\n\n.lateral-movement-report .list-group-item:last-child {\n  border-bottom: none;\n}\n\n/* Filters */\n.lateral-movement-report .form-label {\n  color: #495057;\n  margin-bottom: 8px;\n  font-size: 0.9em;\n}\n\n.lateral-movement-report .form-select {\n  border: 1px solid #ced4da;\n  border-radius: 4px;\n  padding: 8px 12px;\n}\n\n.lateral-movement-report .form-select:focus {\n  border-color: #0d6efd;\n  box-shadow: 0 0 0 0.2rem rgba(13, 110, 253, 0.25);\n}\n\n/* Summary Stats Row */\n.lateral-movement-report .change-stat-item {\n  border-left: 3px solid #0d6efd;\n  padding-left: 12px;\n  margin-bottom: 8px;\n}\n\n/* Loading State */\n.lateral-movement-report .spinner-border {\n  width: 3rem;\n  height: 3rem;\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n  .lateral-movement-report .col-md-3 {\n    margin-bottom: 16px;\n  }\n\n  .lateral-movement-report .table {\n    font-size: 0.9em;\n  }\n\n  .lateral-movement-report .nav-tabs .nav-link {\n    padding: 10px 12px;\n    font-size: 0.9em;\n  }\n}\n\n/* Empty State */\n.lateral-movement-report .empty-state {\n  padding: 60px 20px;\n  text-align: center;\n  color: #6c757d;\n}\n\n.lateral-movement-report .empty-state i {\n  font-size: 4em;\n  margin-bottom: 20px;\n  opacity: 0.5;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
